import React from 'react';
import { motion } from 'framer-motion';

export default function Curriculum() {
  return (
    <section id="curriculum" className="section-padding bg-zinc-950 text-white relative overflow-hidden">
      {/* Background X */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[120%] opacity-10 pointer-events-none z-0">
        <img 
          src="https://media-manager-c.questera.ai/greta-media/471e332637c745cac6e5f952a1669a461aea7ff8853c3b4ee7dd2b5f799ce1f00d91c0ccf6cd346bf4393cbd10a6b0de/images/aW1hZ2UvcG5n/0a2b29dc6ad7a49ac5f22cece9b5e54f.png" 
          alt="Graphic" 
          className="w-full h-full object-contain"
        />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-20">
          <span className="text-brand-red font-bold uppercase tracking-widest text-sm mb-4 block">หลักสูตรเต็ม 2 วัน + Workshop</span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-6">สิ่งที่คุณจะได้เรียนรู้ทีละขั้น</h2>
          <p className="text-xl text-zinc-400 max-w-3xl mx-auto">ออกแบบให้เดินเรื่องจากพื้นฐาน → วิเคราะห์ตัวเอง → วางแผนจริง เพื่อให้ทั้งมือใหม่และมือเก่าต่อยอดได้จริงภายใน 2 วัน</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Day 1 */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-zinc-900 border border-zinc-800 flex flex-col"
          >
            <div className="bg-white text-zinc-900 p-8 border-b-4 border-brand-red">
              <div className="font-black text-3xl mb-2">DAY 01</div>
              <p className="text-brand-red font-bold uppercase tracking-widest text-sm mb-2">19 กันยายน 2569</p>
              <h3 className="text-2xl font-black">รากฐานปาจื้อการเงิน + โปรไฟล์นักลงทุน</h3>
            </div>
            
            <div className="p-8 md:p-10 space-y-10 flex-grow">
              <div>
                <div className="inline-block bg-zinc-800 text-white px-4 py-1 font-bold text-sm uppercase tracking-widest mb-4">
                  เช้า 09.30–12.00 น.
                </div>
                <ul className="space-y-4 text-zinc-300 font-medium">
                  <li className="flex gap-3"><span className="text-brand-red font-black">/</span> ทำไมปาจื้อคือแผนที่การเงินที่แม่นยำที่สุดที่คุณไม่เคยรู้จัก</li>
                  <li className="flex gap-3"><span className="text-brand-red font-black">/</span> ปรับพื้นฐานเร็ว: 5 ธาตุ, ยินหยาง, 10 เทพ — ผ่านมุมมอง "เงิน" ล้วนๆ</li>
                  <li className="flex gap-3"><span className="text-brand-red font-black">/</span> ดาวการเงินของคุณ: ตีความ 10 เทพใหม่ทั้งหมดผ่านเลนส์ความมั่งคั่ง</li>
                </ul>
              </div>

              <div>
                <div className="inline-block bg-zinc-800 text-white px-4 py-1 font-bold text-sm uppercase tracking-widest mb-4">
                  บ่าย 13.00–17.00 น.
                </div>
                <ul className="space-y-4 text-zinc-300 font-medium">
                  <li className="flex gap-3"><span className="text-brand-red font-black">/</span> โปรไฟล์นักลงทุนของคุณ: ดาวไฉ่ตรง vs ดาวไฉ่เด่น กับระดับความเสี่ยง</li>
                  <li className="flex gap-3"><span className="text-brand-red font-black">/</span> แผนที่ทรัพย์สิน 4 เสา + ตาราง 8 ช่อง: ใครคือหุ้นส่วน/คู่ค้าที่เหมาะกับคุณที่สุด</li>
                </ul>
              </div>
            </div>
            
            <div className="bg-brand-red p-6 mt-auto">
              <div className="text-white font-black uppercase text-sm mb-1 tracking-widest">Workshop 1</div>
              <p className="text-white font-medium">วิเคราะห์ดวงตัวเองผ่านซอฟต์แวร์จริงบน Bazi.Fengshuix.com หาดาวการเงินของตัวเองทันทีในห้องเรียน</p>
            </div>
          </motion.div>

          {/* Day 2 */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="bg-zinc-900 border border-zinc-800 flex flex-col"
          >
            <div className="bg-brand-red text-white p-8 border-b-4 border-black">
              <div className="font-black text-3xl mb-2">DAY 02</div>
              <p className="text-black font-bold uppercase tracking-widest text-sm mb-2">20 กันยายน 2569</p>
              <h3 className="text-2xl font-black">การประยุกต์ใช้ + จังหวะเวลาการลงทุน</h3>
            </div>
            
            <div className="p-8 md:p-10 space-y-10 flex-grow">
              <div>
                <div className="inline-block bg-zinc-800 text-white px-4 py-1 font-bold text-sm uppercase tracking-widest mb-4">
                  เช้า 09.30–12.00 น.
                </div>
                <ul className="space-y-4 text-zinc-300 font-medium">
                  <li className="flex gap-3"><span className="text-brand-red font-black">/</span> คลังทรัพย์ (Wealth Vault): ทำไมบางคนเก็บเงินเก่ง บางคนเก็บไม่อยู่ และจะมีเงินก้อนตอนไหน</li>
                  <li className="flex gap-3"><span className="text-brand-red font-black">/</span> ทิศมงคลเสริมการเงิน + เชื่อมเข้ากับฮวงจุ้ย 8 ทิศประจำบ้าน</li>
                  <li className="flex gap-3"><span className="text-brand-red font-black">/</span> นิสัยการเงินตามราศีบน-ล่าง + จัดอันดับ "ตัวช่วยหาเงินที่ดีที่สุด" ในดวง</li>
                </ul>
              </div>

              <div>
                <div className="inline-block bg-zinc-800 text-white px-4 py-1 font-bold text-sm uppercase tracking-widest mb-4">
                  บ่าย 13.00–17.00 น.
                </div>
                <ul className="space-y-4 text-zinc-300 font-medium">
                  <li className="flex gap-3"><span className="text-brand-red font-black">/</span> ระยะพลังทรัพย์ (Wealth Life Stage): ช่วงอายุไหนที่ดวงคุณจะมั่งคั่งที่สุด</li>
                  <li className="flex gap-3"><span className="text-brand-red font-black">/</span> จังหวะทรัพย์ตามดวงจร (Da Yun Timing): วางแผนการลงทุน 10 ปีข้างหน้า</li>
                  <li className="flex gap-3"><span className="text-brand-red font-black">/</span> ความรู้ลับเสริมมั่งคั่ง: ฮวงจุ้ย / พิธีกรรม / คลื่นสมอง</li>
                </ul>
              </div>
            </div>

            <div className="bg-white p-6 mt-auto border-t border-zinc-800">
              <div className="text-brand-red font-black uppercase text-sm mb-1 tracking-widest">Workshop 2</div>
              <p className="text-zinc-900 font-bold">วางแผนการเงิน-การลงทุนส่วนตัว 10 ปีจากดวงจริงของคุณ พร้อม Action Plan ที่จับต้องได้ ก่อนจบหลักสูตร</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}